import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=a4a751e4&"
import script from "./ButtonBar.vue?vue&type=script&lang=js&"
export * from "./ButtonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4a751e4')) {
      api.createRecord('a4a751e4', component.options)
    } else {
      api.reload('a4a751e4', component.options)
    }
    module.hot.accept("./ButtonBar.vue?vue&type=template&id=a4a751e4&", function () {
      api.rerender('a4a751e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/ButtonBar.vue"
export default component.exports